import React from 'react'

export const ArrowRight = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6093)'>
      <path
        d='M11.637 13.05L5.98 7.39498L7.394 5.97998L13.051 11.637L18 6.68698V18H6.687L11.637 13.05Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6093'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
